module.exports = __webpack_public_path__ + "img/DSC_0069.ae5e4b3c.jpg";